import { Component, NgModule,OnInit,OnDestroy,ViewChild,Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router,NavigationExtras, ActivatedRoute } from '@angular/router';
import { Configuration } from '../../../app.constants';
import { AuthService, AppInfoService, PortalStudentLogIn,CollegeDetails } from '../../services';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { DxFormComponent,DxSelectBoxModule,DxRadioGroupModule, DxRadioGroupComponent, DxTemplateModule} from 'devextreme-angular';
import { LanguageenglishService }from '../../services/languageenglish.service';
import { AppConfigService } from '../../../app-config.service';
import { SingleCardComponent } from '../../../layouts/single-card/single-card.component';
import { HeaderComponent  } from '../header/header.component';
import { Md5} from "md5-typescript";
import {HelperService} from '../../services/helper.service';
 

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  providers:[HeaderComponent,SingleCardComponent]
})
export class LoginFormComponent implements OnInit  {
  @ViewChild(DxFormComponent) dataGrid: DxFormComponent;
  @ViewChild("eventRadioGroup") eventRadioGroup: DxRadioGroupComponent;
  @Input()
  formdatasource: any;
  StudeMailId:string;
  Password:string;
  Password1:string;
  data:any;
  CETpdf:string="";
  Notificationpdf:string="";
  Notificationpdf2:string="";
  EnrolmentManualForm:string="";
  OnlinePaymentManual:string="";
  InstructionforEnrolment:string="";
  StandardShcedule:string="";
  prospectpdf:string="";
  UserManual:string="";
  Universitydata:any;
  video1:string="";
  video2:string="";
  usernmtext:string="Your Username";
  loginpgtext:any;
  txtCaptcha:string;
  CaptchaInput:string;
  capatchaTest:boolean=false;
  isLogin:boolean=false;
  formdatasource1:any;
  logindatasource:any;
  check:number=0;
  StuPortal:any;
  StudeMailId1:any;
  LoginAccessdatasource:any;
  private sub: any;
  token:any;
  SSOdatasource:any;
  languageProducts :any;
  Defaultlang:string="English";
  LanguageLabel: any;
  DefaultlangTemp: string;
  public ApplicationTitle:"";
  public logoPath :string="";
  LoadImg:boolean=false;
  prospectshow:number;
  options: string[] = ["Student", "Parent"];
  selectedtype = "Student";
  IsParrent:boolean =false;
  NewRegFlag:string="Y";
  OldRegFlag:string="N";
   constructor(private router: Router, private authService: AuthService, 
    private route: ActivatedRoute,
    public appInfo: AppInfoService,
    public Configuration:Configuration,
    private LanguageenglishService:LanguageenglishService,
    private appConfigService : AppConfigService,
    public SingleCardComponent:SingleCardComponent,
    public HeaderComponent:HeaderComponent,
    private helperService:HelperService
  ) {
      this.languageProducts = LanguageenglishService.getlanguageProducts();
      this.logoPath = this.appConfigService.LogoPath;
      
   }
   /* onChange(e){
    this.Password=Md5.init(this.Password);
   } */
   
  onLoginClick() {
   
    if(this.StudeMailId ==undefined || this.StudeMailId==""){
      //alert("Enter User Name"); 
      this.helperService.showWarningMessage("Enter User Name");
      return;
    }
   
    if(this.Password ==undefined || this.Password==""){
      //alert("Enter Password");
      this.helperService.showWarningMessage("Enter Password");
      return;
    }
   
    this.isLogin=true;
   this.Password1=this.Password;
   if(this.token!=undefined && this.token!=""){
    this.capatchaTest=true;
    
  }
  else{
    this.onCaptchaClick(event);
  }
  if(this.capatchaTest==false){
    this.isLogin=false;
    return;

  }
  this.LoadImg=true;
    this.StudeMailId1=this.StudeMailId;
    debugger
    if(this.selectedtype=="Student")
    {
      this.Configuration.IsParrent=false;
      this.authService.GetSystemUserLogByLoginName(this.StudeMailId)
      .subscribe((data: PortalStudentLogIn[]) => this.logindatasource = data,
      error => {
        alert(error);
        this.isLogin=false;
        this.isLogin=false;
        this.StudeMailId= "";
        this.Password= "";
        this.CaptchaInput ="";
        this.RefreshCaptchaClick(event);
        this.LoadImg=false;
        },
        () => {
        
          if(this.logindatasource.length>0 && this.logindatasource[0].Checkflag=="N"){
                this.isLogin=false;
                this.StudeMailId= "";
                this.Password= "";
                this.CaptchaInput ="";
                this.RefreshCaptchaClick(event);
                this.LoadImg=false;
                //alert("User already logged in the system.");
                this.helperService.showWarningMessage("User already logged in the system.");
                return;
            }
            else{
              this.authService.GetCheckUserLoginAccessForPortal(this.StudeMailId1)
              .subscribe((data: PortalStudentLogIn[]) => this.LoginAccessdatasource = data,
              error => {
                this.LoadImg=false;
              },
              () => {
               if(this.LoginAccessdatasource.length>0 &&this.LoginAccessdatasource[0].IsAccessible==false){
                  // alert("Your Account is Locked.You can login after 60 Minutes.");
                   this.helperService.showWarningMessage("Your Account is Locked.You can login after 60 Minutes.");
                   this.LoadImg=false;
               }
               else{
                if(this.capatchaTest==true){
                  this.StudeMailId= window.btoa(this.StudeMailId);
                  this.Password= window.btoa(this.Password);
                  this.isLogin=true;
                  this.LoadImg=false;
                  }
                this.authService.logIn(this.StudeMailId, this.Password)
                .subscribe((data: PortalStudentLogIn[]) => this.formdatasource = data,
                 error => {
                   alert(error);
                   this.isLogin=false;
                   this.isLogin=false;
                   this.StudeMailId= "";
                   this.Password= "";
                   this.CaptchaInput ="";
                   this.RefreshCaptchaClick(event);
                   this.LoadImg=false;
                 },
                 () => {
                  if(this.formdatasource.length > 0)
                  {
                   
                        let navigationExtras: NavigationExtras = {
                          queryParams: {
                             "StudentID" : this.formdatasource[0].StudentID ,
                             "StudeMailId" : this.formdatasource[0].StudeMailId,
                             "StuPoartlaID":this.formdatasource[0].StuPoartlaID,   
                             "StuGender":this.formdatasource[0].StuGender,
                             "MobileNo":this.formdatasource[0].MobileNo,
                             "PhotoPath":this.formdatasource[0].PhotoPath,
                             "SignPath":this.formdatasource[0].SignPath
                              }
                            }
                            ;
                            this.Configuration.Password = null ;
                            this.Configuration.StudentID = null ;
                            this.Configuration.PhotoPath = null ;
                            this.Configuration.SignPath = null ;
                            this.Configuration.PRNNo=null;
                            this.Configuration.StuPoartlaID =  this.formdatasource[0].StuPoartlaID ;
                            this.Configuration.portalopen ="";
                            this.Configuration.Password = this.Password1;
                            this.Configuration.StudentID = this.formdatasource[0].StudentID ;
                            this.Configuration.PhotoPath = this.formdatasource[0].PhotoPath ;
                            this.Configuration.SignPath = this.formdatasource[0].SignPath ;
                            this.Configuration.StuPoartlaID = this.formdatasource[0].StuPoartlaID ;
                            this.Configuration.AcademicInstanceID = this.formdatasource[0].AcademicInstanceID;
                            this.Configuration.ExamInstanceID = this.formdatasource[0].ExamInstanceID;
                            this.Configuration.prospectshow=this.formdatasource[0].prospectshow;
                            this.Configuration.ExternalFlag=this.formdatasource[0].ExternalFlag;
  
                            this.authService.log(navigationExtras, this.formdatasource[0].LastName + ' ' + this.formdatasource[0].FirstName );
                            this.switchLanguage(this.Defaultlang);
                            this.authService.GetPRNNoByStudentID(this.formdatasource[0].StudentID)
                                .subscribe((data: PortalStudentLogIn[]) => this.formdatasource1 = data,
                                error => {
                                  alert(error);
                                 
                                },
                                () => {
                                  this.Configuration.PRNNo=this.formdatasource1[0].PRNNO;
                                  
                                });
                                this.LoadImg=false;
                          }
                     
                    else{
                      this.isLogin=false;
                      this.StudeMailId= "";
                      this.Password= "";
                      this.CaptchaInput ="";
                      this.RefreshCaptchaClick(event);
                      //alert("Invalid UserName Or Password");
                      this.helperService.showWarningMessage("Invalid UserName Or Password.");
                      this.LoadImg=false;
                      this.check=this.check+1;
                      if(this.check==5){
                        this.StuPortal=[];
                        this.StuPortal.StudeMailId=this.StudeMailId1;
                        this.StuPortal.Minutes=59;
                        this.authService.PostSystemUserAfterLoginForPortal(this.StudeMailId1)
                        .subscribe(value => {
                        },
                        err => {
                        },
                        () => {
                         
                        });
                      }
                      return;
                    }
                 });
               }
              });
            }
         });
    }else
    {
      this.Configuration.IsParrent=true;
      this.authService.GetSystemUserLogByParentLoginName(this.StudeMailId)
      .subscribe((data: PortalStudentLogIn[]) => this.logindatasource = data,
      error => {
        alert(error);
        this.isLogin=false;
        this.isLogin=false;
        this.StudeMailId= "";
        this.Password= "";
        this.CaptchaInput ="";
        this.RefreshCaptchaClick(event);
        this.LoadImg=false;
        },
        () => {
        
          if(this.logindatasource.length>0 && this.logindatasource[0].Checkflag=="N"){
                this.isLogin=false;
                this.StudeMailId= "";
                this.Password= "";
                this.CaptchaInput ="";
                this.RefreshCaptchaClick(event);
                this.LoadImg=false;
                //alert("User already logged in the system.");
                this.helperService.showWarningMessage("User already logged in the system.");
                return;
            }
            else{
              this.authService.GetCheckUserLoginAccessForPortal(this.StudeMailId1)
              .subscribe((data: PortalStudentLogIn[]) => this.LoginAccessdatasource = data,
              error => {
                this.LoadImg=false;
              },
              () => {
               if(this.LoginAccessdatasource.length>0 &&this.LoginAccessdatasource[0].IsAccessible==false){
                  // alert("Your Account is Locked.You can login after 60 Minutes.");
                   this.helperService.showWarningMessage("Your Account is Locked.You can login after 60 Minutes.");
                   this.LoadImg=false;
               }
               else{
                if(this.capatchaTest==true){
                  this.StudeMailId= window.btoa(this.StudeMailId);
                  this.Password= window.btoa(this.Password);
                  this.isLogin=true;
                  this.LoadImg=false;
                  }
                this.authService.parentlogIn(this.StudeMailId, this.Password)
                .subscribe((data: PortalStudentLogIn[]) => this.formdatasource = data,
                 error => {
                   alert(error);
                   this.isLogin=false;
                   this.isLogin=false;
                   this.StudeMailId= "";
                   this.Password= "";
                   this.CaptchaInput ="";
                   this.RefreshCaptchaClick(event);
                   this.LoadImg=false;
                 },
                 () => {
                  if(this.formdatasource.length > 0)
                  {
                   
                        let navigationExtras: NavigationExtras = {
                          queryParams: {
                             "StudentID" : this.formdatasource[0].StudentID ,
                             "StudeMailId" : this.formdatasource[0].StudeMailId,
                             "StuPoartlaID":this.formdatasource[0].StuPoartlaID,   
                             "StuGender":this.formdatasource[0].StuGender,
                             "MobileNo":this.formdatasource[0].MobileNo,
                             "PhotoPath":this.formdatasource[0].PhotoPath,
                             "SignPath":this.formdatasource[0].SignPath
                              }
                            }
                            ;
                            this.Configuration.Password = null ;
                            this.Configuration.StudentID = null ;
                            this.Configuration.PhotoPath = null ;
                            this.Configuration.SignPath = null ;
                            this.Configuration.PRNNo=null;
                            this.Configuration.StuPoartlaID =  this.formdatasource[0].StuPoartlaID ;
                            this.Configuration.portalopen ="";
                            this.Configuration.Password = this.Password1;
                            this.Configuration.StudentID = this.formdatasource[0].StudentID ;
                            this.Configuration.PhotoPath = this.formdatasource[0].PhotoPath ;
                            this.Configuration.SignPath = this.formdatasource[0].SignPath ;
                            this.Configuration.StuPoartlaID = this.formdatasource[0].StuPoartlaID ;
                            this.Configuration.AcademicInstanceID = this.formdatasource[0].AcademicInstanceID;
                            this.Configuration.ExamInstanceID = this.formdatasource[0].ExamInstanceID;
                            this.Configuration.prospectshow=this.formdatasource[0].prospectshow;
                            this.Configuration.ExternalFlag=this.formdatasource[0].ExternalFlag;
  
                            this.authService.log(navigationExtras, this.formdatasource[0].LastName + ' ' + this.formdatasource[0].MiddleName );
                            this.switchLanguage(this.Defaultlang);
                            this.authService.GetPRNNoByStudentID(this.formdatasource[0].StudentID)
                                .subscribe((data: PortalStudentLogIn[]) => this.formdatasource1 = data,
                                error => {
                                  alert(error);
                                 
                                },
                                () => {
                                  this.Configuration.PRNNo=this.formdatasource1[0].PRNNO;
                                  
                                });
                                this.LoadImg=false;
                          }
                     
                    else{
                      this.isLogin=false;
                      this.StudeMailId= "";
                      this.Password= "";
                      this.CaptchaInput ="";
                      this.RefreshCaptchaClick(event);
                      //alert("Invalid UserName Or Password");
                      this.helperService.showWarningMessage("Invalid UserName Or Password.");
                      this.LoadImg=false;
                      this.check=this.check+1;
                      if(this.check==5){
                        this.StuPortal=[];
                        this.StuPortal.StudeMailId=this.StudeMailId1;
                        this.StuPortal.Minutes=59;
                        this.authService.PostSystemUserAfterLoginForPortal(this.StudeMailId1)
                        .subscribe(value => {
                        },
                        err => {
                        },
                        () => {
                         
                        });
                      }
                      return;
                    }
                 });
               }
              });
            }
         });
    }
    
   
      
  }
  GetCheckUserLoginAccessForPortal(){
   
  }
  onEnterKey(e){
    this.onCaptchaClick(event);
    if(this.capatchaTest==false){
      return;
    }
   
   
        if(this.StudeMailId ==undefined || this.StudeMailId==""){
          //alert("Enter User Name");
          this.helperService.showWarningMessage("Enter User Name.");
          return;
        }
        if(this.Password ==undefined || this.Password==""){
         // alert("Enter Password");
          this.helperService.showWarningMessage("Enter Password.");
          return;
        }
      
        this.authService.GetSystemUserLogByLoginName(this.StudeMailId)
        .subscribe((data: PortalStudentLogIn[]) => this.logindatasource = data,
        error => {
          alert(error);
          this.isLogin=false;
          this.isLogin=false;
          this.StudeMailId= "";
          this.Password= "";
          this.CaptchaInput ="";
          this.RefreshCaptchaClick(event);
          },
          () => {
           if(this.logindatasource.length>0){
                if(this.logindatasource[0].Checkflag=="N"){
                  this.isLogin=false;
                  this.StudeMailId= "";
                  this.Password= "";
                  this.CaptchaInput ="";
                  this.RefreshCaptchaClick(event);
                  //alert("User already logged in the system.");
                  this.helperService.showWarningMessage("User already logged in the system.");
                  return;
                }
              }
           else{
            if(this.capatchaTest==true){
              this.StudeMailId= window.btoa(this.StudeMailId);
              this.Password= window.btoa(this.Password);
              this.isLogin=true;
              }
            this.authService.logIn(this.StudeMailId, this.Password)
            .subscribe((data: PortalStudentLogIn[]) => this.formdatasource = data,
            error => {
              alert(error);
              this.isLogin=false;
              this.isLogin=false;
              this.StudeMailId= "";
              this.Password= "";
              this.CaptchaInput ="";
              this.RefreshCaptchaClick(event);
            },
            () => {
         
             if(this.formdatasource.length > 0)
              {
           
                let navigationExtras: NavigationExtras = {
                  queryParams: {
                     "StudentID" : this.formdatasource[0].StudentID ,
                     "StudeMailId" : this.formdatasource[0].StudeMailId,
                     "StuPoartlaID":this.formdatasource[0].StuPoartlaID,   
                     "StuGender":this.formdatasource[0].StuGender,
                     "MobileNo":this.formdatasource[0].MobileNo,
                     "PhotoPath":this.formdatasource[0].PhotoPath,
                     "SignPath":this.formdatasource[0].SignPath
                      }
                    }
                    ;
                    this.Configuration.Password = null ;
                    this.Configuration.StudentID = null ;
                    this.Configuration.PhotoPath = null ;
                    this.Configuration.SignPath = null ;
                    this.Configuration.PRNNo=null;
                    this.Configuration.StuPoartlaID =  this.formdatasource[0].StuPoartlaID ;
                    this.Configuration.portalopen ="";
                    this.Configuration.prospectshow=this.formdatasource[0].prospectshow;
                    this.Configuration.Password = this.Password1;
                    this.Configuration.StudentID = this.formdatasource[0].StudentID ;
                    this.Configuration.PhotoPath = this.formdatasource[0].PhotoPath ;
                    this.Configuration.SignPath = this.formdatasource[0].SignPath ;
                    this.Configuration.StuPoartlaID = this.formdatasource[0].StuPoartlaID ;
                    this.Configuration.AcademicInstanceID = this.formdatasource[0].AcademicInstanceID;
                    this.Configuration.ExamInstanceID = this.formdatasource[0].ExamInstanceID;
                    this.Configuration.ExternalFlag=this.formdatasource[0].ExternalFlag;
                    this.authService.log(navigationExtras, this.formdatasource[0].LastName + ' ' + this.formdatasource[0].FirstName );
                    this.switchLanguage(this.Defaultlang);
                      this.authService.GetPRNNoByStudentID(this.formdatasource[0].StudentID)
                        .subscribe((data: PortalStudentLogIn[]) => this.formdatasource1 = data,
                        error => {
                          alert(error);
                         
                        },
                        () => {
                          debugger;
                          this.Configuration.PRNNo=this.formdatasource1[0].PRNNO;
                          
                        });
             
                
            }
            else{
              this.isLogin=false;
              this.StudeMailId= "";
              this.Password= "";
              this.CaptchaInput ="";
              this.RefreshCaptchaClick(event);
              //alert("Invalid UserName Or Password");
              this.helperService.showWarningMessage("Invalid UserName Or Password.");
              return;
            }
         }); 

           } });
  
  }

  forgetPassword(){

    this.authService.forgetPassword(this.StudeMailId, this.Password);
  }
  register(){
    
    this.authService.register(this.StudeMailId, this.Password);
  }
  registerWithPRN(){    
    this.authService.registerWithPRN(this.StudeMailId, this.Password);
  }
  meritlink(){    
    debugger;
    this.authService.meritlink();
  }
  ngOnInit() {debugger
    let data:any =[];
   this.NewRegFlag =  this.Configuration.NewRegFlag;
   this.OldRegFlag =  this.Configuration.OldRegFlag;

    data= this.appConfigService.loadAppConfig();
console.log(data);
    this.selectedtype = "Student";
    this.Configuration.SelectedLanguage="En";
    this.Configuration.FromProspect=false;
    if(this.Defaultlang =="Marathi") {
      this.Configuration.SelectedLanguage = "Mr";
      this.Configuration.LanguageLabel = this.LanguageenglishService.GetlanguageMarathiList();
    }else if((this.Defaultlang =="English") && (this.Configuration.SelectedLanguage == "Mr")) {
      this.Configuration.SelectedLanguage = "Mr";
      this.Configuration.LanguageLabel = this.LanguageenglishService.GetlanguageMarathiList();
      //this.Configuration.ApplicationTitle =this.Configuration.ApplicationTitleInDevngari;
    }else if((this.Defaultlang =="English") && (this.Configuration.SelectedLanguage == "En")) {
      this.Configuration.SelectedLanguage = "En";
      this.Configuration.LanguageLabel = this.LanguageenglishService.GetlanguageEnglishList();
      this.Configuration.ApplicationTitle =this.appConfigService.ApplicationTitle ;
    }
    else{
      this.Configuration.SelectedLanguage = "En";
      this.Configuration.LanguageLabel = this.LanguageenglishService.GetlanguageEnglishList();      
       
    }
    this.LanguageLabel =this.Configuration.LanguageLabel[0];
    this.SingleCardComponent.ApplicationTitle=this.Configuration.ApplicationTitle;
    this.HeaderComponent.ApplicationTitle=this.Configuration.ApplicationTitle;
    this.sub = this.route.queryParams.subscribe(params => {
      this.token = params["ntk"];
    });
    this.Configuration.ProspectFlag="";
    this.Configuration.ProspectPurchaseFlag="";
    if(this.token!=undefined && this.token!=""){
      this.authService.HttpClientInitializeUknowvaHttpClientForStudent(this.token)
      .subscribe((data: PortalStudentLogIn[]) => this.SSOdatasource = data,
      error => {
      },
      () => {
       
          if(this.SSOdatasource.isValiduser==true){
            this.StudeMailId=this.SSOdatasource.user.LoginName;
            this.Password=this.SSOdatasource.user.LoginPassword;
            this.onLoginClick();
          }
          else{
            //alert("Invalid User");
            this.helperService.showWarningMessage("Invalid User.");
          }
               
      });
    }
    this.RefreshCaptchaClick(event);
    this.loginpgtext=this.Configuration.LoginPageText;
    this.authService.GetPdfLink()
        .subscribe((data: PortalStudentLogIn[]) => this.data = data,
        error => {
          //alert(error);
        },
        () => {
          debugger;
          if(this.data.length > 0){
            this.CETpdf = this.data[0].Message
            this.Configuration.pdflink=this.data[1].Message;
            this.prospectpdf = this.data[2].Message
            this.UserManual = this.data[3].Message
            this.Configuration.SupportContact = this.data[4].Message
            this.Notificationpdf = this.data[5].Message
            this.Notificationpdf2 = this.data[6].Message
            this.EnrolmentManualForm = this.data[7].Message 
            this.OnlinePaymentManual = this.data[8].Message 
            this.InstructionforEnrolment = this.data[9].Message 
            this.StandardShcedule = this.data[10].Message 
            /* this.video1=this.data[4].Message
            this.video2=this.data[5].Message */
          }
        }); 
         this.authService.GetSystemUniversityForFlag("Flag5")
        .subscribe((data: PortalStudentLogIn[]) => this.Universitydata = data,
        error => {
          //alert(error);
        },
        () => {
          ;
          if(this.Universitydata.length > 0){
          this.Configuration.UniversityFlag=this.Universitydata[0].Flag;
          }
        });  
        /* if(this.Configuration.UniversityFlag=="N"){
         this.usernmtext="Your Email";
        }
        if(this.Configuration.UniversityFlag=="Y"){
         this.usernmtext="Your Email / Mobile Number"
        } */
        
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('LoginPage');
    //body.classList.remove("dx-viewport");
    // let approot= document.getElementsByTagName('app-root')[0];
    // approot.classList.remove("screen-medium");
    // approot.classList.remove("screen-large");
    debugger;
    var CollegeURL = 'www.abc.com';    
    var CollegeCode =  "";


    this.Configuration.Collegenm = this.Configuration.ApplicationTitle;
     

    /* this.authService.GetCollegeDetailsForPortal(CollegeURL,CollegeCode)//this.ConfigurationCollegeCode
        .subscribe((data: CollegeDetails[]) => this.data = data,
        error => {
        },
        () => {
          ;
          if(this.data.length > 0){
            this.Configuration.CollegeID = this.data[0].CollegeID; //this.Configuration.LoginPageText;
            //////this.Configuration.Collegenm = this.data[0].CollegeName;
            this.Configuration.Collegenm = this.data[0].UniversityName;
            this.Configuration.ApplicationTitle= this.data[0].UniversityName;
            this.Configuration.ApplicationTitleInDevngari= this.data[0].UniversityNameInDevngari;
            this.Configuration.ProspectFlag= this.data[0].ProspectFlag;
            this.Configuration.ProspectPurchaseFlag= this.data[0].ProspectPurchaseFlag;
            this.Configuration.ContactDetails = this.data[0].ContactDetails;
            this.NewRegFlag=this.data[0].NewRegFlag;
            this.OldRegFlag=this.data[0].OldRegFlag;
            
            this.Configuration.Instructionvideo=this.data[0].Instructionvideo;
            if(this.Configuration.Instructionvideo==""){
              this.Configuration.videoshow=false;
            }else{
              this.Configuration.videoshow=true;
            }
            
          }
        }); */ 
   }

  onCaptchaClick(e){
    var why="";
    if(this.CaptchaInput == null || this.CaptchaInput == undefined || this.CaptchaInput=="" ){
      why += " Please Enter CAPTCHA Code.";
      this.capatchaTest=false;
      }
      if(this.CaptchaInput != null && this.CaptchaInput != undefined && this.CaptchaInput != "" ){
        if(this.ValidCaptcha(this.CaptchaInput) == false){
          why += " The CAPTCHA Code Does Not Match.";
          this.capatchaTest=false;
          }
          if(this.ValidCaptcha(this.CaptchaInput) == true){
            this.capatchaTest=true;
          }
      }
      if(why != ""){
        //alert(why);
        this.helperService.showWarningMessage(why);
        return false;
        }
  }
  
  switchLanguage(language: string) {
    debugger
      if(language =="English") {
        this.Configuration.SelectedLanguage = "En";
        this.Configuration.LanguageLabel = this.LanguageenglishService.GetlanguageEnglishList();
        this.LanguageLabel =this.Configuration.LanguageLabel[0];
      }else{
        this.Configuration.SelectedLanguage = "Mr";
        this.Configuration.LanguageLabel = this.LanguageenglishService.GetlanguageMarathiList();
        this.LanguageLabel =this.Configuration.LanguageLabel[0];
      }
      this.LanguageLabel =this.Configuration.LanguageLabel[0];
   /*    this.SingleCardComponent.ApplicationTitle = this.Configuration.ApplicationTitle;
      this.HeaderComponent.ApplicationTitle=this.Configuration.ApplicationTitle; */
  }
   ValidCaptcha(e){
    var str1 = this.txtCaptcha;
    var str2 = this.CaptchaInput.toUpperCase();
    if (str1 == str2){
    return true;
    }else{
    return false;
    }
    }
    RefreshCaptchaClick(e){
      this.CaptchaInput="";
      var b = Math.ceil(Math.random() * 9)+ '';
      var c = Math.ceil(Math.random() * 9)+ '';
      var d = Math.ceil(Math.random() * 9)+ '';
      var g = Math.ceil(Math.random() * 9)+ '';
      var f = Math.ceil(Math.random() * 9) + '';
      var a = Math.ceil(Math.random() * 9) + '';
      /* var f='';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var charactersLength = characters.length;
      for ( var i = 0; i < 1; i++ ) {
        f += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      var a='';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var charactersLength = characters.length;
      for ( var i = 0; i < 2; i++ ) {
        a += characters.charAt(Math.floor(Math.random() * charactersLength));
      } */
      var code =   b + a + c + f + g + d;
      this.txtCaptcha= code;
      document.getElementById("CaptchaDiv").innerHTML = code;
    }
  ngOnDestroy() {
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('dx-viewport');
    body.classList.remove("LoginPage");
  }
  changeType(e)
  { 
    this.selectedtype =e.value;
     
    if(this.selectedtype =="Student") {
      this.IsParrent=false;
      this.Configuration.IsParrent=false;

    }else
    {
      this.IsParrent=true;
      this.Configuration.IsParrent=true;
    }
  }
  selectionChangedLanguage(e){debugger
    this.Defaultlang=e.value;
    this.DefaultlangTemp=this.Defaultlang;
      if(this.Defaultlang =="English") {
        this.Configuration.SelectedLanguage = "En";
        this.Configuration.LanguageLabel = this.LanguageenglishService.GetlanguageEnglishList();
        /* this.Configuration.Collegenm = this.Configuration.ApplicationTitle; */
        this.Configuration.ApplicationTitle= this.Configuration.Collegenm;        
      }else{
        this.Configuration.SelectedLanguage = "Mr";
        this.Configuration.LanguageLabel = this.LanguageenglishService.GetlanguageMarathiList();
        /* this.Configuration.Collegenm = this.Configuration.ApplicationTitleInDevngari; */
        this.Configuration.ApplicationTitle= this.Configuration.ApplicationTitleInDevngari;
       
      }
      this.LanguageLabel =this.Configuration.LanguageLabel[0];
      this.SingleCardComponent.ApplicationTitle = this.Configuration.Collegenm;//this.Configuration.ApplicationTitle;
      this.HeaderComponent.ApplicationTitle=this.Configuration.Collegenm;//this.Configuration.ApplicationTitle;
    }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxValidationGroupModule,
    DxSelectBoxModule,
    DxRadioGroupModule,
    DxTemplateModule
  ],
  declarations: [ LoginFormComponent ],
  exports: [ LoginFormComponent ]
})
export class LoginFormModule { }
